import LoginForm from "Components/Forms/Login/LoginForm";
import LoginStepOne from "Components/Forms/LoginStepOne/LoginStepOne";
import Register from "Components/Forms/Register/Register";
import TermsConditions from "Pages/TermsConditions/TermsConditions";
import Otp from "Pages/Otp/Otp";
import SuccessData from "Components/Success/SuccessData";
import ChooseSpecialty from "Components/Forms/ChooseSpecialty/ChooseSpecialty";
import BasicAccountInformation from "Components/Forms/BasicAccountInformation/BasicAccountInformation";
import SuccessData2 from "Components/Success/SuccessData2";
import WorkInformation from "Pages/WorkInformation/WorkInformation";
import ContactInformation from "Pages/WorkInformation/ContactInformation";
import MapWithSearch from "Pages/WorkInformation/LocateCompany";
import FinalCompleteData from "Pages/WorkInformation/FinalCompleteData";
import Offers from "Pages/Offers/Offers";
import ProjectManagementRequest from "Pages/ProjectManagementRequest/ProjectManagementRequest";
import AddNewProject from "Pages/AddNewProject/AddNewProject";
import AllProjects from "Pages/AllProjects/AllProjects";
import AllExperts from "Pages/AllExperts/AllExperts";
import ProductDetailsPage from "Pages/ProductDetailsPage/ProductDetailsPage";
import TheExpert from "Pages/AllExperts/TheExpert";
import MyProjects from "Pages/MyProjects/MyProjects";
import ProjectManagementRequestsDetails from "Pages/MyProjects/ProjectManagementRequestsDetails";
import MyProjectDetails from "Pages/MyProjects/MyProjectDetails";
import ProjectOneDetails from "Pages/MyProjects/ProjectOneDetails";
import Chat from "Pages/Chat/Chat";
import PackagesCards from "Pages/Packages/Packages";
import Subscriptions from "Pages/Subscriptions/Subscriptions";
import Archives from "Pages/Archives/Archives";
import MyAccount from "Pages/MyAccount/MyAccount";
import Reports from "Pages/Reports/Reports";
import Layout from "Components/Layout/Layout";
import Home from "Pages/Home/Home";
import NotFound from "Pages/Notfound/NotFound";
import { Navigate, createBrowserRouter } from "react-router-dom";
import LandingPage from "Pages/LandingPage/LandingPage";
import WorkProjects from "Pages/MyProjects/WorkProjects";
import ForgetPassword from "Components/Forms/Login/ForgetPassword";
import Cookies from "js-cookie";
import { useSelector } from "react-redux";
import NewPassword from "Components/Forms/Login/NewPassword";
import Profits from "Pages/Wallet/Wallet";
import OurClinc from "Pages/AllProjects/AllProjects";
import MyProjectsCards from "Pages/MyProjects/MyProjectDetails";
import AddDoctor from "Pages/AllExperts/MyProjects";
import AllDoctors from "Pages/AllExperts/TheExpert";
import AddNewCase from "Pages/Reports/AddNewCase";
import AllCases from "Pages/Reports/Reports";
import Testimonials from "Pages/testimonials/testimonials";
import AddNewTestimonials from "Pages/testimonials/AddNewTestimonials";
import Contact from "Pages/AllProjects/Contact";
import Messages from "Pages/Subsicribed/Messages";
import Languages from "Pages/languages/languages";
import AddNewLangague from "Pages/languages/AddNewLangague";
import Subsicribed from "Pages/Messages/Messages";
import Aboutss from "Pages/MyProjects/Aboutss";
import DentalTourism from "Pages/MyProjects/Dentals";
import SpecialtyOptionsManager from "Pages/Reports/AddNewOption";


// Define a function that checks if the user is authenticated


// Apply the authentication guard to protected routes
// For example, if you want to protect the MyProjects route:
// Replace <MyProjects /> with AuthGuard(<MyProjects />)
// This will ensure that MyProjects is only accessible to authenticated users


let routers = createBrowserRouter([
  
  {
    path:"",
    element: <Layout />,
    children: [

      { path: "OurClinc", element: <OurClinc /> },
      { path: "", element: <OurClinc /> },
   
      {
        path: "myProjects",
        element: <MyProjectsCards   /> 
      },
      {
        path: "AddService",
        element: <MyProjects   /> 
      },
      {
        path: "Aboutuss",
        element: <Aboutss   /> 
      },
      {
        path: "AddNewCase",
        element: <AddNewCase   /> 
      },
      {
        path: "AddDoctor",
        element: <AddDoctor   /> 
      },
      {
        path: "AllDoctors",
        element: <AllDoctors   /> 
      },
      {
        path: "AllCases",
        element: <AllCases   /> 
      },
      {
        path: "Testimonials",
        element: <Testimonials  /> 
      },
      {
        path: "AddNewTestimonials",
        element: <AddNewTestimonials  /> 
      },
      
      {
        path: "languages",
        element: <Languages  /> 
      },
      {
        path: "languages",
        element: <Languages  /> 
      },
      {
        path: "AddNewLangague",
        element: <AddNewLangague  /> 
      },
      {
        path: "Contact",
        element: <Contact  /> 
      },
      {
        path: "Messages",
        element: <Messages  /> 
      },
      {
        path: "Subsicribed",
        element: <Subsicribed  /> 
      },
      {
        path: "Dental",
        element: <DentalTourism  /> 
      },
      {
        path: "AddOption",
        element: <SpecialtyOptionsManager  /> 
      },
      
      
    ]
  },
  { path: "loginForm", element: <LoginForm /> },
  
]);

export default routers;



